import * as React from 'react';
import { useRef } from 'react';

import { cn } from '../../../lib';
import { Label } from '../../label';
import { baseVariants } from '../floating-label';
import './styles.css';
import { ITextarea } from './types';

const Textarea = React.forwardRef<HTMLTextAreaElement, ITextarea>(
  (
    {
      id,
      className,
      error,
      isInvalid,
      value,
      maxLength,
      disabled,
      variant,
      onValueChange,
      onChange,
      wrapperClassName,
      ...props
    },
    ref,
  ) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const valueLength = value?.trim().length ?? '0';
    const charsLeft = +(maxLength || 0) - +valueLength;
    const changeValueHandler = (
      event: React.ChangeEvent<HTMLTextAreaElement>,
    ) => {
      const value = event.target.value;
      if ((maxLength && value.trim().length <= maxLength) || !maxLength) {
        onValueChange?.(value);
      }
      onChange?.(event);
    };

    // useEffect(() => {
    //   const el = textAreaRef.current;
    //   const div = divRef.current;
    //   if (!el || !div) return;

    //   // сбрасываем высоту, чтобы правильно измерить scrollHeight
    //   divRef.current.style.height = '0px';
    //   const scrollHeight = el.scrollHeight;
    //   divRef.current.style.height = `${scrollHeight}px`;
    // }, [value]);

    return (
      <Label htmlFor={id} className={wrapperClassName}>
        <div
          ref={wrapperRef}
          data-disabled={disabled}
          data-is-invalid={isInvalid || Boolean(error)}
          className={cn(
            baseVariants({
              variant,
              disabled,
              isInvalid: isInvalid || Boolean(error),
            }),
            '!rounded-[16px] !p-1',
            className,
          )}
        >
          <textarea
            ref={ref}
            {...props}
            disabled={disabled}
            value={value}
            onChange={changeValueHandler}
            className="m-0 h-full w-full resize-none appearance-none border-none bg-transparent p-0 px-[10px] py-[11px] shadow-none outline-none typography-16r placeholder:text-base-300"
          />
        </div>
        {maxLength && (
          <p className="mt-[6px] px-4 text-base-300 typography-13r">{`${charsLeft.toString()} chars left`}</p>
        )}
      </Label>
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
